import { css } from 'linaria';

export const seasonStartCollections = css`
  background-color: var(--background-accent);
  border-radius: 20px;
  padding: 32px;

  @media (--only-mobile) {
    padding: 24px;
  }
`;

export const seasonStartCollectionsHeaderWrapper = css`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const seasonStartCollectionsTitle = css`
  && {
    font-weight: 700;
    width: unset;
    text-transform: uppercase;
  }
`;

export const seasonStartCollectionsMoreLink = css`
  display: flex;
  column-gap: 4px;
`;

export const seasonStartCollectionsMoreText = css`
  @media (--only-mobile) {
    display: none;
  }
`;

export const seasonStartCollectionsMoreTextMobile = css`
  @media (--from-tablet) {
    display: none;
  }
`;

export const seasonStartCollectionSwiper = css`
  > div {
    @media (--from-desktop) {
      grid-template-columns: repeat(4, 1fr);
    }

    @media (--from-tablet) {
      display: grid;
      row-gap: 24px;
      column-gap: 16px;
    }

    @media (--only-tablet) {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
  }
`;

export const seasonStartCollectionSlide = css`
  && {
    @media (--only-mobile) {
      width: 222px;
      margin-right: 16px;
    }
  }
`;

export const seasonStartCollectionImage = css`
  width: 100%;
  border-radius: var(--rounding-l);
  margin-bottom: 8px;
`;

export const seasonStartCollectionSlideInfo = css`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  row-gap: 4px;
`;
